import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { toggleCoachChat } from "@/components/coach/CoachChatWidget";

const TABS = [
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
        <polyline strokeLinecap="round" strokeLinejoin="round" points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    to: "/zones",
    label: "Zones",
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
      </svg>
    ),
  },
  {
    to: "/history",
    label: "History",
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline strokeLinecap="round" strokeLinejoin="round" points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    to: "/billing",
    label: "Billing",
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
        <line x1="1" y1="10" x2="23" y2="10" />
      </svg>
    ),
  },
] as const;

export function MobileBottomNav() {
  const location = useLocation();
  const path = location.pathname;

  const totalItems = TABS.length + 1; // +1 for Coach button
  const activeIndex = useMemo(() => {
    const idx = TABS.findIndex((tab) => path === tab.to);
    return idx >= 0 ? idx : -1;
  }, [path]);

  return (
    <nav
      aria-label="Mobile navigation"
      className="fixed bottom-0 left-0 right-0 z-40 bg-zinc-900/95 border-t border-zinc-800 backdrop-blur-xl lg:hidden"
    >
      {/* Sliding active indicator */}
      <div className="relative">
        {activeIndex >= 0 && (
          <div
            className="absolute top-0 h-0.5 bg-[rgb(var(--cp))] transition-all duration-300 ease-out"
            style={{
              width: `${100 / totalItems}%`,
              left: `${(activeIndex / totalItems) * 100}%`,
            }}
          />
        )}
      </div>
      <div className="flex items-stretch" style={{ paddingBottom: 'max(8px, env(safe-area-inset-bottom))' }}>
        {TABS.map((tab) => {
          const isActive = path === tab.to;
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`min-w-0 flex flex-1 flex-col items-center gap-1 px-1 py-2.5 transition-colors active:scale-[0.97] transition-transform sm:px-3 ${
                isActive ? "text-[rgb(var(--cp))]" : "text-zinc-500"
              }`}
            >
              {tab.icon}
              <span className="text-[10px] font-medium">{tab.label}</span>
            </Link>
          );
        })}
        <button
          onClick={toggleCoachChat}
          className="min-w-0 flex flex-1 flex-col items-center gap-1 px-1 py-2.5 transition-colors active:scale-[0.97] transition-transform text-zinc-500 active:text-[rgb(var(--cp))] sm:px-3"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.75} aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
          </svg>
          <span className="text-[10px] font-medium">Coach</span>
        </button>
      </div>
    </nav>
  );
}
